module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/IlSx9o/tc-custom/9780830881079.jpg?1696024832505",
      "alt": "This image is the cover for the book Simple Prayer"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Simple Prayer\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Sometimes our walk with God seems so difficult. We struggle to find the time to pray, the words to say, and the way to pray them. Are we making prayer more complicated than it needs to be? Charlie Dawes is a pastor and professor who understands both the desires and the challenges of deepening our prayer lives. He has identified simple, biblical prayers that will help you unlock the mystery of conversing with God by paring our words down to their most elemental level. By focusing our prayers, we can open up a new way of relating with God that we have never before experienced. Simple prayer is far from simplistic. Instead, it will help you connect with God at a heart level that cannot be mastered with words alone.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Charlie Dawes, Mark Batterson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', [_vm._v("Charlie Dawes (DMin, George Fox Evangelical Seminary) is a pastor at Metro Church DC. He was formerly associate vice president for student development at Southeastern University in Lakeland, Florida, as well as assistant professor in practical ministries in the college of Christian ministries and religion. Charlie has served the local church for over seventeen years as a student and young adult pastor and worship leader. He is married to Nicole and they have three children.")]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    InterVarsity Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0